import {Col, List, Row} from "antd";
import {CheckOutlined} from "@ant-design/icons";
import React, {useState} from "react";
import styled from "styled-components";
import moment from "moment";
import {KeyConstant} from "../../../can/weighing-slip/constant/keyConstant";
import CalendarParent from "../model/calendarModalParentMobile";

const StyledList = styled(List)`
  .ant-spin-container {
    height: ${(props) => props?.height + "px"};
    overflow-y: auto;
  }

  .ant-list-item {
    display: list-item !important;
    padding-right: 12px !important;
  }
`;
const RenderKeyCustom = ({type, handleSelect}) => {

    const [startDate, setStartDate] = useState(moment())
    const [endDate, setEndDate] = useState(moment())
    const [visible, setVisible] = useState()
    const dataListCustom = () => {
        return [
            {
                title: "Ngày bắt đầu",
                date: startDate,
                keyName: KeyConstant.CUSTOM,
                type: "startDate"
            },
            {
                title: "Ngày kết thúc",
                date: endDate,
                keyName: KeyConstant.CUSTOM,
                type: "endDate"
            }
        ]
    }

    const checkDate = () => {
        return moment(startDate).format("YYYYMMDD") > moment(endDate).format("YYYYMMDD")
    }

    return (
        <div className={"px-6"}>
            <StyledList
                header={null}
                footer={null}
                bordered={false}
                dataSource={dataListCustom()}
                renderItem={(item) => (
                    <List.Item>
                        <Row className={"items-center"}>
                            <Col span={23}>
                                <div className={"flex flex-col"}
                                     onClick={() => {
                                         handleSelect(
                                             {
                                                 startDate: startDate,
                                                 endDate: endDate,
                                                 key: item.keyName
                                             })
                                         setVisible(item.type)
                                     }}>
                                        <span style={{
                                            color: type === item.keyName ? "#007FFF" : ""
                                        }}>
                                            {item.title}
                                        </span>
                                    <span
                                        style={{textDecoration: checkDate() && item.type === "endDate" ? "line-through" : ""}}>
                                        {
                                            moment(item.date).format("dddd, DD MMMM YYYY").charAt(0).toUpperCase() +
                                            moment(item.date).format("dddd, DD MMMM YYYY").slice(1)
                                        }
                                    </span>
                                </div>
                            </Col>
                            <Col span={1}>
                                {
                                    type === item.keyName &&
                                    <CheckOutlined style={{color: "#007FFF"}}/>
                                }
                            </Col>
                        </Row>
                    </List.Item>
                )}
            />

            <CalendarParent visible={visible === "startDate"}
                            onCancel={() => setVisible(undefined)}
                            date={startDate}
                            onData={(date) => {
                                let startDateTemp = moment(date);
                                let endDateTemp = endDate;
                                setStartDate(startDateTemp)
                                if (moment(date).format("YYYYMMDD") > moment(endDate).format("YYYYMMDD")) {
                                    setEndDate(startDateTemp)
                                }
                                handleSelect(
                                    {
                                        startDate: startDateTemp,
                                        endDate: endDateTemp,
                                        key: KeyConstant.CUSTOM
                                    })
                            }}/>
            <CalendarParent visible={visible === "endDate"}
                            onCancel={() => setVisible(undefined)}
                            date={endDate}
                            onData={(date) => {
                                let endDateTemp = moment(date);
                                let startDateTemp = startDate;
                                setEndDate(endDateTemp)
                                handleSelect(
                                    {
                                        startDate: startDateTemp,
                                        endDate: endDateTemp,
                                        key: KeyConstant.CUSTOM
                                    })
                            }}/>
        </div>
    )
}

export default RenderKeyCustom
